import React from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            Más los <span className="text-[#39FF14]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {/* Bono 1 */}
          <div className="bg-[#001a0d] border border-[#39FF14] rounded-2xl p-6 flex flex-col" data-id="element-8">
            <div className="text-4xl font-black text-[#39FF14] mb-1" data-id="element-9">01</div>
            <div className="text-[#39FF14] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
              Kit "Aula Lista em 10 Min"
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
              Transformá cualquier clase en una clase dinámica y ordenada en 10
              minutos. Incluye el Framework ProfePack 10', 12 Rituales de
              Inicio, 10 Exit Tickets listos y 6 Cierres con Broche.
            </p>
            <div className="flex items-center gap-2" data-id="element-13">
              <span className="text-gray-400 line-through text-sm" data-id="element-14">$8.000</span>
              <span className="bg-[#39FF14] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#001a0d] border border-[#39FF14] rounded-2xl p-6 flex flex-col" data-id="element-16">
            <div className="text-4xl font-black text-[#39FF14] mb-1" data-id="element-17">02</div>
            <div className="text-[#39FF14] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
              Falsos Amigos & Errores Top 100
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
              Los 100 errores más frecuentes del alumno argentino: Falsos Amigos
              mortales, errores gramaticales, de vocabulario y de pronunciación.
              Con 12 mini-quizzes listos.
            </p>
            <div className="flex items-center gap-2" data-id="element-21">
              <span className="text-gray-400 line-through text-sm" data-id="element-22">
                $10.000
              </span>
              <span className="bg-[#39FF14] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#001a0d] border border-[#39FF14] rounded-2xl p-6 flex flex-col" data-id="element-24">
            <div className="text-4xl font-black text-[#39FF14] mb-1" data-id="element-25">03</div>
            <div className="text-[#39FF14] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
              Banco de Rúbricas + Notas Listas
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
              12 rúbricas imprimibles para oralidad, escritura y proyectos +
              banco de 30 comentarios tipo + tracker de notas por trimestre.
            </p>
            <div className="flex items-center gap-2" data-id="element-29">
              <span className="text-gray-400 line-through text-sm" data-id="element-30">$9.000</span>
              <span className="bg-[#39FF14] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#001a0d] border border-[#39FF14] rounded-2xl p-6 flex flex-col" data-id="element-32">
            <div className="text-4xl font-black text-[#39FF14] mb-1" data-id="element-33">04</div>
            <div className="text-[#39FF14] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
              Megapack Jogos & Dinâmicas
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
              52 dinámicas listas para levantar cualquier grupo: warm-ups,
              juegos imprimibles, dinámicas de oralidad y evaluables. Sin wifi.
              Sin preparación.
            </p>
            <div className="flex items-center gap-2" data-id="element-37">
              <span className="text-gray-400 line-through text-sm" data-id="element-38">$8.000</span>
              <span className="bg-[#39FF14] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#001a0d] border border-[#39FF14] rounded-2xl p-6 flex flex-col" data-id="element-40">
            <div className="text-4xl font-black text-[#39FF14] mb-1" data-id="element-41">05</div>
            <div className="text-[#39FF14] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
              Plantillas Editables: Comunicados
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
              12 comunicados pre-hechos para todo el año, 10 mensajes WhatsApp
              copy-paste, agenda docente imprimible y Contrato de Clase.
            </p>
            <div className="flex items-center gap-2" data-id="element-45">
              <span className="text-gray-400 line-through text-sm" data-id="element-46">$7.000</span>
              <span className="bg-[#39FF14] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#001a0d] border border-[#39FF14] rounded-2xl p-6 flex flex-col" data-id="element-48">
            <div className="text-4xl font-black text-[#39FF14] mb-1" data-id="element-49">06</div>
            <div className="text-[#39FF14] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
              Sistema "Oralidad Sin Miedo"
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
              30 Role Plays imprimibles por escenarios reales, 12 micro-diálogos
              de 2 minutos, guía de corrección oral y rúbrica oral express.
            </p>
            <div className="flex items-center gap-2" data-id="element-53">
              <span className="text-gray-400 line-through text-sm" data-id="element-54">$9.000</span>
              <span className="bg-[#39FF14] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#39FF14]/40 rounded-2xl p-6 text-center bg-[#000d08]" data-id="element-56">
          <p className="text-[#39FF14] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
            <span className="text-gray-400 line-through text-lg" data-id="element-59">$51.000</span>
            <span className="text-[#39FF14] text-2xl font-black tracking-wide" data-id="element-60">
              🎁 GRATIS — Solo por hoy
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-61">
            Incluidos en las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}